import { getNowInPreferredTimezone, parsePreferredWallClock } from "helpers/dateTimeHelper";

export function isQuotingDeadlineAfterMinimum(
  date: string | null | undefined,
  time: string | null | undefined,
  minimumMinutes: number,
  explicitTz?: string | null,
): boolean {
  const deadline = parsePreferredWallClock(date, time, explicitTz);
  if (!deadline) {
    return false;
  }

  const now = getNowInPreferredTimezone(explicitTz);
  return deadline.diff(now, "minutes") > minimumMinutes;
}

export function isConfirmationAfterQuotingDeadline(
  quotingDate: string | null | undefined,
  quotingTime: string | null | undefined,
  confirmationDate: string | null | undefined,
  confirmationTime: string | null | undefined,
  explicitTz?: string | null,
): boolean {
  const quotingDeadline = parsePreferredWallClock(quotingDate, quotingTime, explicitTz);
  const confirmationDeadline = parsePreferredWallClock(confirmationDate, confirmationTime, explicitTz);

  if (!quotingDeadline || !confirmationDeadline) {
    return false;
  }

  return confirmationDeadline.isAfter(quotingDeadline);
}

export function isConfirmationAfterQuoting(
  quotingDate: string | undefined,
  quotingTime: string | undefined,
  confirmationDate: string | undefined,
  confirmationTime: string | undefined,
  explicitTz?: string | null,
): boolean {
  if (!quotingDate || !confirmationDate) {
    return true;
  }

  return isConfirmationAfterQuotingDeadline(quotingDate, quotingTime, confirmationDate, confirmationTime, explicitTz);
}
